import { useMutation } from '@tanstack/react-query';
import { appointmentsApi } from '@/lib/api';
import { AxiosError } from 'axios';

export function useRecoverAppointment() {
  return useMutation({
    mutationFn: async (data: { customerEmail: string; customerCpf: string }) => {
      const response = await appointmentsApi.recoverAppointmentId(data);
      return response.data;
    },
    onError: (error: AxiosError<{ error: string }>) => {
      console.error('Recovery request failed:', error.message);
    },
  });
}
